import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaGoogle, FaApple, FaFacebookF } from 'react-icons/fa';

export default function LoginPage({ language = 'en' }) {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: '', password: '' });

  const labels = {
    en: {
      title: 'Login to Your Account',
      email: 'Email Address',
      password: 'Password',
      login: 'Login',
      register: "Don't have an account? Register",
    },
    es: {
      title: 'Inicia sesión en tu cuenta',
      email: 'Correo electrónico',
      password: 'Contraseña',
      login: 'Iniciar sesión',
      register: '¿No tienes cuenta? Regístrate',
    },
    pt: {
      title: 'Entre na sua conta',
      email: 'Email',
      password: 'Senha',
      login: 'Entrar',
      register: 'Não tem uma conta? Cadastre-se',
    },
  };

  const t = labels[language];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Integrar lógica de autenticación aquí
    console.log(formData);
  };

  return (
    <>
      <section
        id="login"
        className="bg-[#48887B] py-12 text-center scroll-mt-[120px] pt-[120px]"
      >
        <h2 className="text-white text-3xl md:text-5xl font-bold">{t.title}</h2>
      </section>

      <div className="max-w-md mx-auto py-12 px-6">
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block mb-1 font-medium" htmlFor="email">{t.email}</label>
            <input
              type="email"
              id="email"
              name="email"
              required
              value={formData.email}
              onChange={handleChange}
              className="w-full border border-gray-300 px-4 py-2 rounded-lg"
            />
          </div>
          <div>
            <label className="block mb-1 font-medium" htmlFor="password">{t.password}</label>
            <input
              type="password"
              id="password"
              name="password"
              required
              value={formData.password}
              onChange={handleChange}
              className="w-full border border-gray-300 px-4 py-2 rounded-lg"
            />
          </div>
          <button
            type="submit"
            className="w-full px-6 py-2 bg-[#48887B] text-white rounded-lg hover:bg-[#3b726a] transition"
          >
            {t.login}
          </button>
        </form>

        <div className="my-6 text-center text-gray-500">or</div>

        <div className="flex flex-col gap-4">
          <button className="flex items-center justify-center gap-2 px-4 py-2 border rounded-lg text-gray-700 hover:bg-gray-100">
            <FaGoogle /> Google
          </button>
          <button className="flex items-center justify-center gap-2 px-4 py-2 border rounded-lg text-gray-700 hover:bg-gray-100">
            <FaFacebookF /> Meta
          </button>
          <button className="flex items-center justify-center gap-2 px-4 py-2 border rounded-lg text-gray-700 hover:bg-gray-100">
            <FaApple /> Apple
          </button>
        </div>

        <div className="mt-6 text-center">
          <button
            onClick={() => navigate('/register')}
            className="text-sm text-[#48887B] hover:underline"
          >
            {t.register}
          </button>
        </div>
      </div>
    </>
  );
}
